<div class="sd-header">
  <div class="sd-header-content">
    <div class="banner">
      <div class="app-name autoid-portal-name">
      </div>

      <div class="dev-environment">
        <span *ngIf="isDevEnvironment">(DEV)</span>
      </div>
    </div>
  </div>
</div>
<div class="terms-page">
  <h1 i18n>Terms and Conditions</h1>
  <div #content class="terms-content" (scroll)="onScrollContent()">
    <div *ngIf="termsContent$ | async as termsContent" [innerHTML]="termsContent | safeHtml"></div>
  </div>
  <p-footer>
    <p-button styleClass="p-button-danger" (click)="onClickDecline()" i18n-label label="I do not accept"></p-button>
    <p-button
      styleClass="p-button-success"
      (click)="onClickAccept()"
      i18n-label
      label="I accept"
      [disabled]="!hasScrolledToBottom"
      [pTooltip]="tooltipMessage"
      tooltipPosition="top"
      tooltipStyleClass="conditions-tooltip"
    ></p-button>
  </p-footer>
</div>
<div class="sd-footer">
  <div class="sd-footer-content"></div>
</div>
